require('./hireWelcomeAccountStep1.scss');

// @vendor
import React from 'react';
import PropTypes from 'prop-types';

// @components
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');
import HireWelcomeAccountLegalCheckbox from '../../hireWelcomeAccountLegalCheckbox/hireWelcomeAccountLegalCheckbox';
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const ContractInformation = require('routes/contractsView/components/ContractInformation/ContractInformation');

// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');

// @constants
const {
    PRODUCT_TYPE_ACCOUNT,
    PRODUCT_HIRING_COMPONENT_ID
} = require('constants/hiringProductInformation');
const {
    FIRST_STEP,
    SAVINGS_ACCOUNT_WELCOME,
    SAVINGS_ACCOUNT_WELCOME_PAYROLL,
} = require('constants/index');
const {
    GC,
    WEB_GC_ENABLED,
} = require('constants/flagBasedFeatures');

const buildProductInformationSection = (props) => {
    const { flagBasedFeatures, welcomeAccountPayroll, immHireWelcomeAccount } = props;
    const productAlias = welcomeAccountPayroll ? 'bienvenidaNomina' : 'bienvenida';
    let content;
    if (flagBasedFeatures.get(WEB_GC_ENABLED) && flagBasedFeatures.get(GC)) {
        content = (
            <HiringProductInformation
                productAlias={productAlias}
                productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                productType={PRODUCT_TYPE_ACCOUNT}
                precontractualLinkTarget="_blank"
            />
        );
    } else {
        const { getContractInformation, immProfileFields } = props;
        const component = {
            cms_key: productAlias
        };
        const contractWizard = immHireWelcomeAccount.getIn(['steps', FIRST_STEP, 'cmsStepInfo']);

        content = (
            <ContractInformation
                component={component}
                contractWizard={contractWizard}
                getContractInformation={getContractInformation}
                getContractInformationWithPricing={getContractInformation}
                immProfile={immProfileFields}
            />
        );
    }

    return content;
}

const HireWelcomeAccountStep1 = (props) => {
    const {
        contractName,
        disableSendButton,
        hasPolling,
        immHireWelcomeAccount,
        immPreContractualPolling,
        onLegalTextRead,
        isLegalTextRead,
        immProfileFields,
        offerAccountData,
        onCheckboxChange,
        preContractualMail,
        productName,
        requestProfile,
        sendPreContractualMail,
        setTermsAndCondsText,
        standar,
        subType,
        type,
        welcomeAccountPayroll
    } = props;
    const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
    const profileError = immProfileFields.get('error');
    const hasBeenEmailSent = !preContractualMail.get('mailSent');
    const product = welcomeAccountPayroll ? SAVINGS_ACCOUNT_WELCOME_PAYROLL : SAVINGS_ACCOUNT_WELCOME;
    const sendMailParams = { subType, type, standar, productName, product };
    const checkboxValue = immHireWelcomeAccount.getIn(['confirmationCheckboxes', 'value']);
    const checkboxError = immHireWelcomeAccount.getIn(['confirmationCheckboxes', 'errorState']);
    const checkboxErrorMessage = immHireWelcomeAccount.getIn(['confirmationCheckboxes', 'errorMessage']);
    const productInformationSection = buildProductInformationSection(props);
    return (
        <article className="legal-confirmation">
            <section className="contract-confirmation-step__confirmation-section">
                {productInformationSection}
                <PreContractualMailInfo
                    biggerLegalTexts
                    hasPolling={hasPolling}
                    disableSendButton={disableSendButton}
                    email={clientEmail}
                    isLegalTextRead={isLegalTextRead}
                    onLegalTextRead={onLegalTextRead}
                    sendEmail={sendPreContractualMail}
                    requestProfile={requestProfile}
                    preContractualMail={preContractualMail}
                    immPreContractualPolling={immPreContractualPolling}
                    profileError={profileError}
                    contractName={contractName}
                    sendMailParams={sendMailParams}
                />
                <HireWelcomeAccountLegalCheckbox
                    checkboxError={checkboxError}
                    checkboxErrorMessage={checkboxErrorMessage}
                    checkboxValue={checkboxValue}
                    contractName={contractName}
                    hasBeenEmailSent={hasBeenEmailSent}
                    immHireWelcomeAccount={immHireWelcomeAccount}
                    offerAccountData={offerAccountData}
                    onCheckboxChange={onCheckboxChange}
                    setTermsAndCondsText={setTermsAndCondsText}
                    welcomeAccountPayroll={welcomeAccountPayroll}
                />
            </section>
        </article>
    )
}

HireWelcomeAccountStep1.propTypes = {
    contractName: PropTypes.string.isRequired,
    disableSendButton: PropTypes.bool,
    flagBasedFeatures: PropTypes.object.isRequired,
    getContractInformation: PropTypes.func.isRequired,
    hasPolling: PropTypes.bool,
    immHireWelcomeAccount: PropTypes.object.isRequired,
    immPreContractualPolling: PropTypes.object,
    immProfileFields: PropTypes.object.isRequired,
    isLegalTextRead: PropTypes.bool,
    onLegalTextRead: PropTypes.func,
    offerAccountData: PropTypes.object.isRequired,
    onCheckboxChange: PropTypes.object.isRequired,
    preContractualMail: PropTypes.object.isRequired,
    productName: PropTypes.string.isRequired,
    requestProfile: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    standar: PropTypes.string.isRequired,
    subType: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    welcomeAccountPayroll: PropTypes.bool.isRequired
}

HireWelcomeAccountStep1.defaultProps = {
    disableSendButton: false,
    hasPolling: false,
    isLegalTextRead: null,
    immPreContractualPolling: null,
    offerAccountData: null,
    onLegalTextRead: null,
}

export default HireWelcomeAccountStep1;
